export default __webpack_public_path__ + "static/media/logo.314ac218.png";